import React, { Component } from "react";

class FancyCounter extends Component {
    render() {
        return(
            <>
            <section id="counter_area">
                <div class="facts">
                    <div class="container">
                        <div class="col-md-3 col-xs-12 col-sm-6 columns">
                            <div class="facts-wrap">
                                <div class="graph">
                                    <div class="graph-left-side">
                                        <div class="graph-left-container">
                                            <div class="graph-left-half"></div>
                                        </div>
                                    </div>
                                    <div class="graph-right-side">
                                        <div class="graph-right-container">
                                            <div class="graph-right-half"></div>
                                        </div>
                                    </div>
                                    <i class="fa fa-group fa-3x fw"></i>

                                    <div class="facts-wrap-num">
                                        <span class="counter">21</span>
                                    </div>
                                </div>
                                <h6>Participants</h6>
                            </div>
                        </div>
                        <div class="col-md-3 col-xs-12 col-sm-6 columns">
                            <div class="facts-wrap">
                                <div class="graph">
                                    <div class="graph-left-side">
                                        <div class="graph-left-container">
                                            <div class="graph-left-half"></div>
                                        </div>
                                    </div>
                                    <div class="graph-right-side">
                                        <div class="graph-right-container">
                                            <div class="graph-right-half"></div>
                                        </div>
                                    </div>
                                    <i class="fa fa-graduation-cap fa-3x fw"></i>

                                    <div class="facts-wrap-num"><span class="counter">29</span></div>
                                </div>
                                <h6>Working hours</h6>
                            </div>
                        </div>
                        <div class="col-md-3 col-xs-12 col-sm-6 columns">
                            <div class="facts-wrap">
                                <div class="graph">
                                    <div class="graph-left-side">
                                        <div class="graph-left-container">
                                            <div class="graph-left-half"></div>
                                        </div>
                                    </div>
                                    <div class="graph-right-side">
                                        <div class="graph-right-container">
                                            <div class="graph-right-half"></div>
                                        </div>
                                    </div>
                                    <i class="fa fa-calendar fa-3x fw"></i>

                                    <div class="facts-wrap-num"><span class="counter">10</span></div>
                                </div>
                                <h6>Days</h6>
                            </div>
                        </div>
                        <div class="col-md-3 col-xs-6 col-sm-6 columns">
                            <div class="facts-wrap">
                                <div class="graph">
                                    <div class="graph-left-side">
                                        <div class="graph-left-container">
                                            <div class="graph-left-half"></div>
                                        </div>
                                    </div>
                                    <div class="graph-right-side">
                                        <div class="graph-right-container">
                                            <div class="graph-right-half"></div>
                                        </div>
                                    </div>
                                    <i class="fa fa-play fa-3x fw"></i>

                                    <div class="facts-wrap-num">&#x221E;</div> 
                                </div>
                                <h6>Fun</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </>
        )
    }
}
export default FancyCounter;